import gsap from 'gsap'
import SplitType from 'split-type'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const config = {
  start: 'top 85%',
  end: 'bottom bottom',
  once: true,
  toggleClass: 'is-inview',
  invalidateOnRefresh: true
}

const animationHeading = () => {
  let lines
  let delay
  let words
  let headings

  headings = document.querySelectorAll('[data-heading], [data-heading] p')

  if (!headings.length) return

  headings.forEach((heading) => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: heading,
        config
      }
    })
    lines = new SplitType(heading, { types: 'lines' })
    lines.lines.forEach((line, i) => {
      words = new SplitType(line, { types: 'words' })
      tl.to(
        words.words,
        {
          y: 0,
          x: 0,
          duration: 1.2,
          rotate: '0deg',
          ease: 'power3.inOut'
        },
        `-=${i == 0 ? 0 : 1.1}`
      )
    })
  })
}

const animationBlur = () => {
  const els = document.querySelectorAll('[data-blur]')

  if (!els.length) return

  els.forEach((el) => {
    gsap.from(el, {
      scrollTrigger: {
        trigger: el,
        config
      },
      duration: 1,
      opacity: 0.1,
      filter: 'blur(20px)',
      ease: 'power2.inOut'
    })
  })
}

export const runAnimations = () => {
  document.fonts.ready.then(() => {
    animationHeading()
    animationBlur()
  })
}

export default () => {}
